import React from 'react'
import { Row, Col } from 'reactstrap';
import { Redirect, Switch, Route } from "react-router-dom";
import { MenuDasFuncionalidades } from "../Menu/index";
import { connect } from 'react-redux';
import * as actionsRedux from '../Store/Actions/index';
import { CardCrud } from '../Conteudo/Cards/index';
import { convertToSlug } from '../Basicos/funcoes';
import AssociadorDeGrupos from '../Conteudo/AssociadorDeGrupos';
import AssociadorDeGruposProfessor from '../Conteudo/AssociadorDeGruposProfessor';

function Professores({ professores, }) {
    return (
        <Row noGutters={true}>
            <MenuDasFuncionalidades
                funcionalidade={"Professores"}
                classNavBar="navbar-consultas"
                titulo="Professores"
            />
            <Col sm={12} md={12} className="col-conteudo">
                <Switch>
                    {professores.map((subFuncionalidade, indice) => {
                        switch (convertToSlug(subFuncionalidade.descricao)) {
                            case "grupos":
                                return (
                                    <Route
                                        key={subFuncionalidade.url}
                                        path={subFuncionalidade.url}
                                        render={(props) => <AssociadorDeGruposProfessor
                                            {...props}
                                            subFuncionalidade={subFuncionalidade}
                                            indiceSubFuncionalidade={indice}
                                            funcionalidade={"professores"}
                                        />
                                        }
                                    />
                                );
                            case "professores":
                                return null;
                            default:
                                return (
                                    <Route
                                        key={subFuncionalidade.url}
                                        path={subFuncionalidade.url}
                                        render={(props) =>  <CardCrud 
                                                                {...props}
                                                                subFuncionalidade={subFuncionalidade}
                                                                indiceSubFuncionalidade={indice}
                                                                funcionalidade={"professores"} 
                                                            />
                                                }
                                    />
                                );
                        }
                    })}
                    <Route render={() => <Redirect to="/" />} />
                </Switch>
            </Col>
        </Row>
    )
}

const mapDispatchToProps = (dispatch) => {
    return {
        desativarModal: () => dispatch(actionsRedux.desativarModalSubFuncionalidade()),
    }
}

const mapStateToProps = (state) => {
    // console.log(state.subFuncionalidades)
    return {
        professores: state.subFuncionalidades.professores,
        estruturaModal: state.subFuncionalidades.estruturaModal,
        estadoModal: state.subFuncionalidades.estadoModal,
        adicionar: state.subFuncionalidades.adicionar,
        editarFunc: state.subFuncionalidades.editar,
        tipoAcao: state.subFuncionalidades.tipoAcao,
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Professores)